export const faqItems = [
  { id: 0, title: 'faq:question1', content: 'faq:answer1' },
  { id: 1, title: 'faq:question2', content: 'faq:answer2' },
  { id: 2, title: 'faq:question3', content: 'faq:answer3' },
  { id: 3, title: 'faq:question4', content: 'faq:answer4' },
  { id: 4, title: 'faq:question5', content: 'faq:answer5' },
  { id: 5, title: 'faq:question6', content: 'faq:answer6' },
  { id: 6, title: 'faq:question7', content: 'faq:answer7' },
  { id: 7, title: 'faq:question8', content: 'faq:answer8' },
  { id: 8, title: 'faq:question9', content: 'faq:answer9' },
  { id: 9, title: 'faq:question10', content: 'faq:answer10' },
  { id: 10, title: 'faq:question11', content: 'faq:answer11' },
  { id: 11, title: 'faq:question12', content: 'faq:answer12' },
];
